// @flow
import * as React from "react";
import { useState } from "react";
import type { Game } from "../../common/types";
import GameAdminSmartCheckInFormSearch from "./GameAdminSmartCheckInFormSearch";
import GameAdminSmartCheckInFormValidate from "./GameAdminSmartCheckInFormValidate";
import GameAdminSmartCheckInFormList from "./GameAdminSmartCheckInFormList";

type Props = {
  game: Game,
  gameRef: any,
  handleClose: Function,
};

/**
 * 1. Hole Reservierung
 * 2. Zeige Besucher + Begleitungen an
 * 3. Wähle An- / Ab wer dabei ist
 * 4. Checke Ein - Zähler zählen hoch und runter
 * 5. Async werden die Besucherdaten ins Besucherlog geschrieben ( + timestamp )
 */

function GameAdminSmartCheckInForm({
  game,
  gameRef,
  handleClose,
  ticketReservations,
  keepOpen,
  setKeepOpen,
  step,
  setStep,
}: Props) {
  const [ticketReservation, setTicketReservation] = useState(null);

  return step === 1 ? (
    <GameAdminSmartCheckInFormSearch
      ticketReservations={ticketReservations}
      game={game}
      setStep={setStep}
      setTicketReservation={setTicketReservation}
    />
  ) : step === 2 ? (
    <GameAdminSmartCheckInFormValidate
      gameRef={gameRef}
      game={game}
      setStep={setStep}
      handleClose={handleClose}
      ticketReservation={ticketReservation}
      keepOpen={keepOpen}
      setKeepOpen={setKeepOpen}
    />
  ) : (
    <GameAdminSmartCheckInFormList
      ticketReservations={ticketReservations}
      setStep={setStep}
      setTicketReservation={setTicketReservation}
    />
  );
}

export default GameAdminSmartCheckInForm;
